import { SURCHARGES_CATEGORY } from '../../checklistCategories';
import { formatBooleanDataPointValue, formatContextDate, formatMoney } from '../../shared/format';
import type { ApprovalQueueItem } from '../../types';

import type { SurchargeCheckRowView, SurchargePeriodRowView } from './types';

export function buildSurchargesQueueItem(row: SurchargeCheckRowView): ApprovalQueueItem {
  const uncoveredFestiveDates = (row.festiveDates ?? []).filter((festiveDate) => !festiveDate.covered);

  return {
    categoryId: SURCHARGES_CATEGORY.id,
    categoryLabel: SURCHARGES_CATEGORY.label,
    description:
      row.sourceNote ??
      (uncoveredFestiveDates.length > 0
        ? `No surcharge or blackout covers ${uncoveredFestiveDates.map((festiveDate) => formatContextDate(festiveDate.date)).join(', ')}.`
        : `${row.name} surcharge rule requires review.`),
    details: row.details,
    id: row.id,
    title: row.name,
  };
}

export function buildSurchargeTableQueueItem(row: SurchargePeriodRowView): ApprovalQueueItem {
  return {
    categoryId: SURCHARGES_CATEGORY.id,
    categoryLabel: SURCHARGES_CATEGORY.label,
    description: `${row.name} surcharge requires review.`,
    details: [
      { label: 'Period', value: `${formatContextDate(row.fromDate)} – ${formatContextDate(row.toDate)}` },
      { label: 'Converted Cost', value: formatMoney(row.convertedCost, row.currencyCode) },
      { label: 'Surcharge Price', value: formatMoney(row.surchargePrice, row.currencyCode) },
      { label: 'Accumulate', value: formatBooleanDataPointValue({ dataAvailable: true, enabled: row.accumulate }) },
      {
        label: 'Inside Travel Period',
        value: formatBooleanDataPointValue({
          dataAvailable: row.insideTravelPeriod !== null,
          enabled: row.insideTravelPeriod ?? false,
        }),
      },
      {
        label: 'Blackout Overlap',
        value: formatBooleanDataPointValue({
          dataAvailable: row.blackoutOverlap !== null,
          enabled: row.blackoutOverlap ?? false,
        }),
      },
    ],
    id: row.id,
    title: row.name,
  };
}

export function getSurchargesSearchText(row: SurchargeCheckRowView) {
  return [row.name, row.field, row.statusLabel].join(' ');
}

export function getSurchargeTableSearchText(row: SurchargePeriodRowView) {
  return [row.name, row.statusLabel].join(' ');
}
